"use client";
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { getBlogAdminToken, clearBlogAdminToken } from "../../lib/api";

/**
 * Guards the blog admin area. Requires a valid `blogadmin_token` (validated
 * against the backend). Redirects to the login page otherwise.
 */
export default function BlogAdminProtectedRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState("checking"); // checking | ok | denied

  useEffect(() => {
    let active = true;
    const token = getBlogAdminToken();
    if (!token) {
      setStatus("denied");
      return;
    }
    api.blogAdmin
      .me()
      .then(() => active && setStatus("ok"))
      .catch(() => {
        clearBlogAdminToken();
        if (active) setStatus("denied");
      });
    return () => {
      active = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#252F4F]" />
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/blog-admin/login" replace state={{ from: location }} />;
  }

  return children;
}
